export enum SearchResultType {
  Guest = 'guest',
  Invoice = 'invoice',
  Booking = 'inquiry',
}
